module.exports = __webpack_public_path__ + "static/media/call_24px.df11b75a.svg";